<template>
  <div class="product-range">
    <!-- Not empty -->
  </div>
</template>

<script>

/**
 * Vue: Product range (product-range)
 * -----------------------------------------------------------------------------
 * Global product spec template.
 *
 */
export default {
  name: 'ProductRange',

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>
